import React from 'react';
import { motion } from 'framer-motion';
import { Play, TrendingUp } from 'lucide-react';

const PracticeSetCard = ({ 
  set, 
  performance, 
  onStartPractice, 
  index = 0 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow"
    >
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              {set.title}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm mb-3">
              {set.description}
            </p>
          </div>
          {set.adaptive && (
            <TrendingUp className="h-5 w-5 text-purple-600" title="Adaptive Learning" />
          )}
        </div>

        <div className="flex items-center space-x-2 mb-4">
          <span className="px-2 py-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded text-xs">
            {set.topic}
          </span>
          <span className="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded text-xs">
            {set.difficulty}
          </span>
        </div>

        <div className="space-y-2 mb-4">
          <div className="flex justify-between text-sm">
            <span className="text-gray-600 dark:text-gray-400">Questions:</span>
            <span className="font-medium">{set.questions.length}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-600 dark:text-gray-400">Time Limit:</span>
            <span className="font-medium">{set.timeLimit} min</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-600 dark:text-gray-400">Passing Score:</span>
            <span className="font-medium">{set.passingScore}%</span>
          </div>
        </div>

        {performance && performance[set.id] && (
          <div className="mb-4 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
            <div className="flex justify-between text-sm">
              <span className="text-gray-600 dark:text-gray-400">Last Score:</span>
              <span className="font-medium">{performance[set.id].lastScore}%</span>
            </div>
            <div className="flex justify-between text-sm mt-1">
              <span className="text-gray-600 dark:text-gray-400">Attempts:</span>
              <span className="font-medium">{performance[set.id].attempts}</span>
            </div>
          </div>
        )}

        <button
          onClick={() => onStartPractice(set)}
          className="w-full flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          <Play className="h-4 w-4 mr-2" />
          Start Practice
        </button>
      </div>
    </motion.div>
  );
};

export { PracticeSetCard };
